/* @ts-nocheck */
/* eslint-disable */
var hsDrawerCheck = setInterval(function(){
if (document.querySelectorAll('.hs-finalize-purchase').length) {
    clearInterval(hsDrawerCheck);
    var $target = document.querySelectorAll('.hs-finalize-purchase')[0];
    $target.innerHTML = document.querySelector('#hs-checkbox-como-terms').innerHTML + $target.innerHTML;
    document.querySelector('#hs-checkbox-como-terms').remove();
}
}, 1000);

document.querySelectorAll('.app-ot-cookie-manager').forEach(function(node){
    node.addEventListener('click', function(e){
        document.querySelectorAll('.ot-floating-button__open')[0].click();
        return false;
    });
});

var collectionsHideSavingsText = "bao-bao-issey-miyake,homme-plisse-issey-miyake,issey-miyake,me-issey-miyake,pleats-please-issey-miyake,132-5-issey-miyake,im-men".split(',').map(function(vendor) {
    return vendor.replaceAll('-',' ');
});
var collectionsNoLinebreak = "bao-bao-issey-miyake,homme-plisse-issey-miyake,pleats-please-issey-miyake".split(',');

var boostMarketsEnabled = "false" == 'false' ? false : true;

document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll('.wishlist-engine-cart').forEach(btn => { cartWishlistBtn(btn); });
    const cartWishlistObserver = new MutationObserver(cartWishlistObserverCallback);
    cartWishlistObserver.observe(document.getElementById('CartDrawer'), { childList: true, subtree: true });
});

document.addEventListener("cart:updated", () => {
    document.querySelectorAll('.wishlist-engine-cart').forEach(btn => { cartWishlistBtn(btn); });
});

(function($){

function c21CarouselUpdateUI($wrap, slick, current) {
    var total = slick.slideCount;
    var visible = slick.options.slidesToShow;
    var pct = total > 0 ? Math.min(100, Math.round((current + visible) / total * 100)) : 100;
    $wrap.find('.c21-carousel-progress__bar').css('width', pct + '%');
}

function c21CarouselToggleUI($wrap, slick) {
    var $ui = $wrap.find('.c21-carousel-ui');
    if (slick.options.slidesToShow >= slick.slideCount) {
        $ui.css('display', 'none');
    } else {
        $ui.css('display', 'flex');
    }
}

$(function(){
    $('.slick-featured-collection').each(function(){
        var $this = $(this),
            autoplaySpeed = parseInt($this.attr('slick-autoplay-speed')),
            autoplaySpeedMobile = parseInt($this.attr('slick-autoplay-speed-mobile')),
            perSlide = parseInt($this.attr('slick-per-slide')),
            perSlideMobile = parseInt($this.attr('slick-per-slide-mobile'));

        var $wrap = $this.closest('.c21-carousel-wrap');
        var hasCustomNav = $wrap.length > 0;

        $this.on('init', function() {
            $this.find('.slick-list').css('overflow','visible');
        });

        $this.on('init', function(event, slick) {
            if (hasCustomNav) {
                c21CarouselToggleUI($wrap, slick);
                if (slick.slideCount > slick.options.slidesToShow) {
                    c21CarouselUpdateUI($wrap, slick, 0);
                }
            }
        });

        if (hasCustomNav) {
            $this.on('afterChange', function(event, slick, current) {
                c21CarouselUpdateUI($wrap, slick, current);
            });
            $this.on('breakpoint', function(event, slick) {
                c21CarouselToggleUI($wrap, slick);
            });
        }

        var slickOpts = {
            mobileFirst: true,
            autoplay: autoplaySpeedMobile > 0,
            autoplaySpeed: autoplaySpeedMobile * 1000,
            slidesToScroll: perSlideMobile,
            slidesToShow: perSlideMobile,
            infinite: true,
            arrows: hasCustomNav,
            prevArrow: `<button type="button" class="c21-carousel-prev slick-prev" aria-label="Previous"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg></button>`,
            nextArrow: `<button type="button" class="c21-carousel-next slick-next" aria-label="Next"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></button>`,
            responsive: [
            {
                breakpoint: 750,
                settings: {
                autoplay: autoplaySpeed > 0,
                autoplaySpeed: autoplaySpeed * 1000,
                slidesToScroll: perSlide,
                slidesToShow: perSlide
                }
            }
            ]
        };
        if (hasCustomNav) {
            slickOpts.appendArrows = $wrap.find('.c21-carousel-nav');
        }
        $this.slick(slickOpts);
    });

    var productSingleDescriptionFullWidthMod = setInterval(function(){
    if ($('.product-single__description-full').length && $(window).width() >= 768) {
        $('.product-single__description-full').css({
        width: $('.product-slideshow').outerWidth()*0.5,
        marginLeft: parseInt($('.product-single__description-full').css('margin-left')) + $('.product-slideshow').outerWidth()*0.25 + 'px'
        });
        clearInterval(productSingleDescriptionFullWidthMod);
    }
    }, 300);

    $('#PageContainer').on('click', '.variant-input input:radio + label', function(){
        $(this).parents('fieldset').find('.variant-input input:radio + label').removeClass('selected');
        $(this).addClass('selected');
    });

    $('#MainContent').on('click', '.gktAccountWidgetActivator', function() {
        $('.gktAccountWidgetModal').css('height','fit-content');
        setTimeout(function() {
            var $giftTab = $('.gktAccountWidgetBodyTabGiftCards');
            var $rewardTab = $('.gktAccountWidgetBodyTabRewards');
            var $giftSection = $('.gktAccountWidgetGiftCardSection');
            var $rewardSection = $('.gktAccountWidgetRewardSection');

            $rewardTab.removeClass('gktAccountWidgetBodyTabActive');
            $giftTab.addClass('gktAccountWidgetBodyTabActive');
            $rewardSection.hide();
            $giftSection.show(); 

            giftkartAccountWidgetTabsOberserver.observe(document.querySelector('.gktAccountWidgetBodyTabs'), { subtree:true, childList:true });
            $('.gktAccountWidgetModalWrapper').on('click.gktAccountWidgetBodyTabs', '.gktAccountWidgetBodyTabGiftCards,.gktAccountWidgetBodyTabRewards', function() {                $('.gktAccountWidgetFooter').css('visibility',$(this).hasClass('gktAccountWidgetBodyTabGiftCards') ? 'visible' : 'hidden');
            });
            $('<div class="gktAccountWidgetFooter rte" style="padding:10px 0 0;font-size:14px;line-height:1.5em;visibility:hidden;">To retrieve gift code, please check the email that was sent. For further assistance, contact <a href="mailto:customerservice@club21global.com">customerservice@club21global.com</a></div>').appendTo('.gktAccountWidgetModal');
            if ($giftTab.hasClass('gktAccountWidgetBodyTabActive')) {
                $('.gktAccountWidgetFooter').css('visibility','hidden');
            }
        }, 2000);
    });

    $('#MainContent').on('click', '.gktAccountWidgetModalClose', function() {
        $('.gktAccountWidgetModalWrapper').off('click.gktAccountWidgetBodyTabs');
    });

    if (document.querySelector('.boost-sd__filter-block') != null) {
        boostCollectionsObserver.observe(document.querySelector('.boost-sd__filter-block'), {
            childList: true,
            subtree: true
        });
    }

});


var boostCollectionsObserver = new MutationObserver(function(records) {
    for (rec of records) {
        if (rec.target.className.includes('boost-sd__product-item')) {
            boostCollectionGridSalesPriceFormat([rec.target], collectionsHideSavingsText);
        }
        else if (rec.target.querySelectorAll('.boost-sd__product-item').length > 0) {
            boostCollectionGridSalesPriceFormat(rec.target.querySelectorAll('.boost-sd__product-item'), collectionsHideSavingsText);
        }
        else if (rec.target.querySelectorAll('.boost-sd__filter-option-item-amount:not(.filter-count-sanitized)').length > 0) {
            boostCollectionFilterRemoveCountBrackets(rec.target.querySelectorAll('.boost-sd__filter-option-item-amount:not(.filter-count-sanitized)'));
        }
        else if (rec.target.querySelectorAll('.boost-sd__filter-option-title').length > 0) {
            boostCollectionFilterNoLinebreak(rec.target.querySelectorAll('.boost-sd__filter-option-title'));
        }
        else
            continue;
    }
});

function boostCollectionGridSalesPriceFormat(items, collectionsHideSavingsText) {
    for ($item of items) {
        var $saleNode = $($item).find('.boost-sd__product-price-wrapper > .boost-sd__product-price-saving');
        if ($saleNode.length > 0) {
            if (collectionsHideSavingsText.includes($($item).find('.boost-sd__product-vendor').text().replace(/\./g,'').toLowerCase())) {
                $($item).find('.boost-sd__product-price').addClass('boost-sd__product-price--alt');
            }
            else {
                var $compareNode = $($item).find('.boost-sd__product-price-wrapper > .boost-sd__product-price-content > .boost-sd__format-currency--price-compare');
                $saleNode.detach().insertBefore($compareNode);
            }
        }
    }
}

function boostCollectionFilterRemoveCountBrackets(filterCount) {
    $(filterCount).each(function(){
        var count = $(this).html().replace(/[()]+/g,'');
        $(this).addClass('filter-count-sanitized').html(count);
    });
}

function boostCollectionFilterNoLinebreak(options) {
    for (option of options) {
        var $optionTitle = $(option);
        if ($optionTitle.text().toLowerCase() == 'designers') {
            $optionTitle.parents('.boost-sd__filter-option').find('.boost-sd__filter-option-item-label').each(function() {
                if (collectionsNoLinebreak.includes($(this).text().replaceAll(' ','-').replaceAll(',','').toLowerCase())) {
                    $(this).addClass('no-linebreak');
                }
            });
        }
    }
}

var giftkartAccountWidgetTabsOberserver = new MutationObserver(mutations => {
    mutations.forEach(m => {
        console.log('giftkartAccountWidgetTabsOberserver: ',m.target.className)
        if (m.target.className.includes('gktAccountWidgetBodyTabActive')) {
            console.log(m.target.className)
            console.log('gift card tab is active');
        }
    });
});

})(jQuery);
(function($){
    function computeDeliveryLocation(sku, mappedSet){
        var loc = 'Singapore';
        var s = (sku || '').trim();
        if (!s) return loc;
        var sNorm = s.toUpperCase();
        if (mappedSet && mappedSet.has(sNorm)) {
            return 'Singapore/Malaysia';
        }
        if (sNorm.indexOf('3000') === 0) return 'Malaysia';
        return loc;
    }

    function getSkuNode(){
        return document.querySelector('.product-single__sku[data-sku]');
    }

    function updateDeliveryOrigin(){
        var $origin = $('.delivery-origin').first();
        if ($origin.length === 0) return;

        var skuNode = getSkuNode();
        var sku = skuNode ? (skuNode.textContent || '').trim() : '';
        var set = window._club21_mappedSkus || new Set();
        var loc = computeDeliveryLocation(sku, set);
        $origin.html('&bull; This product is delivered from ' + loc + '.');
    }

    window.club21UpdateDeliveryOrigin = updateDeliveryOrigin;

    function bootstrapMappedFromSnippet(){
        var el = document.getElementById('mapped-skus-json');
        if (!el) {
            try { console.warn('[DeliveryOrigin] mapped-skus-json script not found in DOM'); } catch(e){}
            return false;
        }
        try {
            var raw = el.textContent || '';
            try { console.info('[DeliveryOrigin] mapped-skus-json raw length=', raw.length); } catch(e){}
            var arr = JSON.parse(raw || '[]');
            if (Array.isArray(arr) && arr.length === 1 && typeof arr[0] === 'string' && (arr[0].indexOf('\n') !== -1 || arr[0].indexOf('\r') !== -1)) {
                arr = arr[0].split(/\r?\n/);
            }
            window._club21_mappedSkus = new Set();
            arr.forEach(function(v){ if (v && typeof v === 'string') window._club21_mappedSkus.add(v.trim().toUpperCase()); });
            try { console.info('[DeliveryOrigin] mapped-skus loaded count=', window._club21_mappedSkus.size); } catch(e){}
            window._club21_mappedSkusLoaded = true;
            return true;
        } catch (e) {
            try { console.error('[DeliveryOrigin] failed to parse mapped-skus-json', e); } catch(e){}
            return false;
        }
    }

    function initDeliveryOrigin(){
        var $origin = $('.delivery-origin').first();
        if ($origin.length === 0) { window.club21DeliveryObserverActive = false; return; }

        bootstrapMappedFromSnippet();
        updateDeliveryOrigin();

        var skuNode = getSkuNode();
        if (skuNode) {
            try {
                new MutationObserver(function(){ updateDeliveryOrigin(); })
                    .observe(skuNode, { childList: true, characterData: true, subtree: true });
                window.club21DeliveryObserverActive = true;
            } catch (e) {
                window.club21DeliveryObserverActive = false;
            }
        } else {
            window.club21DeliveryObserverActive = false;
        }
    }

    $(function(){ initDeliveryOrigin(); });
})(jQuery);


(function() {
    function observeModal() {
        const root = document.getElementById('socialphotos-root');
        if (!root) return false;
        new MutationObserver(() => {
            const modal = document.getElementById('socialphotos-upload-modal');
            const hidden = !modal || window.getComputedStyle(modal).display === 'none' || !modal.classList.contains('in');
            if (hidden) {
                if (!document.getElementById('socialphotos-success-overlay')) {
                    var overlay = document.createElement('div');
                    overlay.id = 'socialphotos-success-overlay';
                    overlay.style = 'position:fixed;top:0;left:0;width:100vw;height:100vh;display:flex;align-items:center;justify-content:center;z-index:9999;background:#000000BF;';
                    var msg = document.createElement('div');
                    var uploadBtn = document.querySelector('#socialphotos-root button, #socialphotos-root input[type="submit"]');
                    if (uploadBtn) {
                        msg.className = uploadBtn.className;
                    }
                    msg.textContent = 'Redirecting...';
                    msg.style.fontFamily = 'Neue Haas Unica, sans-serif';
                    msg.style.fontSize = '18px';
                    msg.style.fontWeight = 'normal';
                    msg.style.color = '#222222';
                    msg.style.background = '#fff';
                    msg.style.padding = '32px 64px';
                    msg.style.minWidth = '220px';
                    overlay.appendChild(msg);
                    document.body.appendChild(overlay);
                }
                setTimeout(function() {
                    window.location.href = '/pages/thank-you';
                }, 1200);
            }
        }).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
        return true;
    }
    if (!observeModal()) {
        const poll = setInterval(() => { if (observeModal()) clearInterval(poll); }, 300);
    }
})();


document.addEventListener('variant:change', function(e) {
  var variant = e.detail && e.detail.variant;
  if (!variant) return;
  if (window.Shopify && window.Shopify.country !== 'SG') return;

    var sku = variant.sku || '';
    var newPrice = (window.theme && window.theme.PriceUtils)
        ? window.theme.PriceUtils.applySGMultiplierWithSKU(variant.price, sku)
        : Math.round(variant.price);
    var newCompareAtPrice = variant.compare_at_price ? (
        (window.theme && window.theme.PriceUtils)
            ? window.theme.PriceUtils.applySGMultiplierWithSKU(variant.compare_at_price, sku)
            : Math.round(variant.compare_at_price)
    ) : null;

    var formatted = (window.theme && window.theme.PriceUtils)
        ? window.theme.PriceUtils.format(newPrice)
        : 'S$' + Math.round(newPrice / 100);
    var formattedCompare = newCompareAtPrice ? (
        (window.theme && window.theme.PriceUtils)
            ? window.theme.PriceUtils.format(newCompareAtPrice)
            : 'S$' + Math.round(newCompareAtPrice / 100)
    ) : '';

  var priceEl = document.querySelector('[data-product-price] strong');
  if (priceEl) priceEl.textContent = formatted;

  var compareEl = document.querySelector('[data-compare-price]');
  if (compareEl) compareEl.textContent = formattedCompare;
    if (!window.club21DeliveryObserverActive) {
        if (window.club21UpdateDeliveryOrigin) {
            try { window.club21UpdateDeliveryOrigin(); } catch (e) {}
        }
    }
});


const cartWishlistObserverCallback = (mutations, o) => {
    for (const m of mutations) {
        if (m.type === 'childList') {
            m.addedNodes.forEach(node => {
                if (node.nodeType === 1) {
                    if (node.classList.contains('cart__items')) {
                        const wishlistBtns = node.querySelectorAll('.wishlist-engine-cart');
                        wishlistBtns.forEach(btn => {
                            cartWishlistBtn(btn);
                        });
                        __this._cartPageAction(); // reinit wishlist app's button function
                    }
                }
            });
        }
    }
}
(function() {
    var zokoSvg = '<svg width="56" height="56" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><defs><clipPath id="zoko_clip_1"><rect width="16" height="16" /></clipPath></defs><g clip-path="url(#zoko_clip_1)"><path d="M13.601 2.32606C12.1195 0.830216 10.0993 -0.00785542 7.994 5.57899e-05C3.627 5.62668e-05 0.068 3.55806 0.064 7.92606C0.064 9.32506 0.43 10.6861 1.121 11.8911C1.121 11.8911 0 16.0001 0 16.0001C0 16.0001 4.204 14.8981 4.204 14.8981C5.36649 15.5323 6.66975 15.8641 7.994 15.8631C7.994 15.8631 7.998 15.8631 7.998 15.8631C12.366 15.8631 15.924 12.3051 15.928 7.93306C15.9299 5.82905 15.0921 3.81079 13.6003 2.32639C13.6003 2.32639 13.601 2.32606 13.601 2.32606Z" fill="#4F97AB" transform="translate(0 -0)" /><path d="M6.58701 13.183C5.40619 13.1821 4.24724 12.8644 3.23101 12.263C3.23101 12.263 2.99101 12.119 2.99101 12.119L0.497012 12.773L1.16301 10.34C1.16301 10.34 1.00701 10.089 1.00701 10.089C0.346818 9.03934 -0.00234139 7.82404 1.18017e-05 6.58401C1.18017e-05 2.95801 2.95701 1.06096e-05 6.59101 1.06096e-05C8.33962 -0.00312603 10.0171 0.691991 11.251 1.93101C12.4889 3.16539 13.1829 4.84283 13.179 6.59101C13.175 10.23 10.218 13.183 6.58701 13.183Z" fill="#FFFFFF" transform="translate(1.407 1.338)" /><path d="M7.64 5.322C7.443 5.223 6.47 4.744 6.287 4.676C6.105 4.611 5.972 4.577 5.842 4.775C5.709 4.972 5.329 5.421 5.215 5.55C5.101 5.683 4.983 5.698 4.785 5.6C4.588 5.5 3.949 5.292 3.193 4.615C2.603 4.09 2.208 3.44 2.09 3.243C1.976 3.045 2.079 2.939 2.178 2.84C2.265 2.752 2.375 2.608 2.474 2.494C2.574 2.38 2.607 2.296 2.672 2.164C2.737 2.03 2.706 1.916 2.657 1.817C2.607 1.718 2.212 0.741 2.045 0.347C1.885 -0.0419998 1.722 0.0120001 1.6 0.00699997C1.486 0 1.353 0 1.22 0C1.01699 0.00516748 0.825301 0.0946693 0.691 0.247C0.509 0.445 0 0.924 0 1.901C0 2.878 0.71 3.817 0.81 3.95C0.908 4.083 2.204 6.082 4.193 6.942C4.663 7.147 5.033 7.268 5.322 7.36C5.797 7.512 6.226 7.489 6.568 7.44C6.948 7.382 7.739 6.96 7.906 6.497C8.07 6.033 8.07 5.637 8.02 5.554C7.971 5.47 7.838 5.421 7.64 5.322Z" fill="#4F97AB" transform="translate(3.969 4.265)" /></g></svg>';

    var zokoSelector = '[id^="zoko"] > [class^="reset"] > img';

    function replaceZokoImg(img) {
        if (img.dataset.zokoReplaced) return;
        img.dataset.zokoReplaced = '1';
        img.style.display = 'none';
        var wrapper = document.createElement('span');
        wrapper.style.cssText = 'display:inline-flex;cursor:pointer;';
        wrapper.innerHTML = zokoSvg;
        wrapper.addEventListener('click', function() { img.click(); });
        img.parentNode.insertBefore(wrapper, img);
    }

    function findAndReplaceZokoEls() {
        document.querySelectorAll(zokoSelector).forEach(replaceZokoImg);
    }

    new MutationObserver(function(records) {
        for (var rec of records) {
            rec.addedNodes.forEach(function(node) {
                if (node.nodeType !== 1) return;
                if (node.matches && node.matches(zokoSelector)) {
                    replaceZokoImg(node);
                } else {
                    node.querySelectorAll(zokoSelector).forEach(replaceZokoImg);
                }
            });
        }
    }).observe(document.body, { childList: true, subtree: true });

    findAndReplaceZokoEls();
})();

(function() {
    function styleSewpWishlistBtn(btn) {
        btn.removeAttribute('style');
        btn.classList.add('btn', 'btn--secondary');
    }

    function observeSewpPopup(popup) {
        popup.querySelectorAll('button.wishlist-cart').forEach(styleSewpWishlistBtn);
        new MutationObserver(function(records) {
            for (var rec of records) {
                if (rec.type === 'attributes' && rec.attributeName === 'style' && rec.target.matches('button.wishlist-cart')) {
                    rec.target.removeAttribute('style');
                } else if (rec.type === 'childList') {
                    rec.addedNodes.forEach(function(node) {
                        if (node.nodeType !== 1) return;
                        if (node.matches('button.wishlist-cart')) {
                            styleSewpWishlistBtn(node);
                        } else {
                            node.querySelectorAll('button.wishlist-cart').forEach(styleSewpWishlistBtn);
                        }
                    });
                }
            }
        }).observe(popup, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
    }

    new MutationObserver(function(records) {
        for (var rec of records) {
            rec.addedNodes.forEach(function(node) {
                if (node.nodeType !== 1) return;
                if (node.id === 'sewp-engine-popup') {
                    observeSewpPopup(node);
                } else {
                    var popup = node.querySelector('#sewp-engine-popup');
                    if (popup) observeSewpPopup(popup);
                }
            });
        }
    }).observe(document.body, { childList: true, subtree: false });
})();

const cartWishlistBtn = node => {
    node.addEventListener('click', function() {
        this.querySelector('path').style.fill = '#000000';
        this.querySelector('.wishlist-engine-cart--text').textContent = "Moved to wishlist";
    });
}

(function () {
    var searchBtn = document.querySelector('.js-search-header');
    if (!searchBtn) return;
    searchBtn.addEventListener('click', function () {
        setTimeout(function () {
            var uploadBtn = document.querySelector('#SiteHeader birse-img-upload-button');
            if (uploadBtn) uploadBtn.click();
        }, 300);
    });
})();

(function () {
    function getVariantId(form) {
        var addBtn = form.querySelector('[data-add-to-cart]');
        return addBtn ? addBtn.dataset.variantId : null;
    }

    function isVariantInCart(cart, variantId) {
        return cart.items.some(function (item) {
            return String(item.variant_id) === String(variantId);
        });
    }

    function setInCartState(form, inCart) {
        var addBtn = form.querySelector('[data-add-to-cart]');
        if (!addBtn) return;
        if (addBtn.dataset.available === 'false') return;

        var textEl = addBtn.querySelector('[data-add-to-cart-text]');

        addBtn.disabled = inCart;
        addBtn.classList.toggle('is-in-cart', inCart);

        if (textEl) {
            textEl.textContent = inCart ? textEl.dataset.alreadyInCartText : textEl.dataset.defaultText;
        }

        var checkoutWrap = form.querySelector('[data-checkout-button-wrap]');
        if (checkoutWrap) checkoutWrap.classList.toggle('hide', !inCart);

        document.dispatchEvent(new CustomEvent('pdp:buy-state-changed'));
    }

    function refreshCartState(form) {
        var variantId = getVariantId(form);
        if (!form || !variantId) return;

        theme.cart.getCart().then(function (cart) {
            if (getVariantId(form) !== variantId) return;
            setInCartState(form, isVariantInCart(cart, variantId));
        });
    }

    function refreshAllForms() {
        document.querySelectorAll('.product-single__form').forEach(refreshCartState);
    }

    document.addEventListener('DOMContentLoaded', refreshAllForms);

    document.addEventListener('ajaxProduct:added', function (evt) {
        evt.stopImmediatePropagation();

        var addBtn = evt.detail && evt.detail.addToCartBtn;
        var form = addBtn && addBtn.closest('form');
        if (form) refreshCartState(form);
    }, true);

    document.addEventListener('variant:change', function (evt) {
        var variant = evt.detail && evt.detail.variant;
        if (!variant) return;

        document.querySelectorAll('.product-single__form').forEach(function (form) {
            var addBtn = form.querySelector('[data-add-to-cart]');
            if (addBtn) {
                addBtn.dataset.variantId = variant.id;
                addBtn.dataset.available = variant.available;
            }
            refreshCartState(form);
        });
    });

    document.addEventListener('cart:updated', function (evt) {

        var cart = evt.detail && evt.detail.cart;
        if (!cart) { refreshAllForms(); return; }

        document.querySelectorAll('.product-single__form').forEach(function (form) {
            var variantId = getVariantId(form);
            if (variantId) setInCartState(form, isVariantInCart(cart, variantId));
        });
    });
})();

function isMobile() {
    return window.matchMedia('(max-width: 768px)').matches;
}

function isStackedProduct() {
    var imagesEl = document.querySelector('[data-product-images]');
    return !!imagesEl && imagesEl.dataset.galleryLayout === 'stacked';
}

if ('IntersectionObserver' in window) {
    (function () {
        var addBtn = document.querySelector('.product-single__form [data-add-to-cart]');
        var sentinel = document.querySelector('.product-single__form [data-buy-floating-sentinel]');
        var footer = document.querySelector('.site-footer');
        if (!addBtn || !sentinel) return;

        var buttonOutOfView = false;
        var footerVisible = false;

        function updateFloatingState() {
            var isFloating = isMobile() && !isStackedProduct() && buttonOutOfView && !footerVisible;
            document.body.classList.toggle('pdp-buy-floating', isFloating);

            if (isFloating) {
                var form = addBtn.closest('form');
                var inCart = addBtn.classList.contains('is-in-cart');
                var visibleEl = inCart && form ? form.querySelector('[data-checkout-button-wrap]') : addBtn;
                if (visibleEl) {
                    var bottomOffset = parseFloat(getComputedStyle(visibleEl).bottom) || 0;
                    document.documentElement.style.setProperty(
                        '--floating-total-height',
                        (visibleEl.getBoundingClientRect().height + (bottomOffset*1.5)) + 'px'
                    );
                }
            }
        }

        new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                buttonOutOfView = !entry.isIntersecting;
                updateFloatingState();
            });
        }, { rootMargin: '-20px 0px 0px 0px' }).observe(sentinel);

        if (footer) {
            var footerSettleTimer = null;
            new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    clearTimeout(footerSettleTimer);
                    var isIntersecting = entry.isIntersecting;
                    footerSettleTimer = setTimeout(function () {
                        footerVisible = isIntersecting;
                        updateFloatingState();
                    }, 150);
                });
            }, { rootMargin: '0px 0px -100px 0px' }).observe(footer);
        }

        document.addEventListener('pdp:buy-state-changed', updateFloatingState);

        var floatingResizeTimer;
        window.addEventListener('resize', function () {
            clearTimeout(floatingResizeTimer);
            floatingResizeTimer = setTimeout(updateFloatingState, 250);
        });
    })();
}

if ('IntersectionObserver' in window) {
    (function () {
        var addBtn = document.querySelector('.product-single__form [data-add-to-cart]');
        var sentinel = document.querySelector('.product-single__form [data-buy-floating-sentinel]');
        if (!addBtn || !sentinel) return;

        var buttonBelowViewport = true;

        function updatePeekState() {
            var showPeek = isMobile() && isStackedProduct() && buttonBelowViewport;
            document.body.classList.toggle('pdp-buy-peek', showPeek);
        }

        new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    buttonBelowViewport = false;
                } else {
                    buttonBelowViewport = entry.boundingClientRect.top >= 0;
                }
            });
            updatePeekState();
        }).observe(sentinel);

        updatePeekState();

        var peekResizeTimer;
        window.addEventListener('resize', function () {
            clearTimeout(peekResizeTimer);
            peekResizeTimer = setTimeout(updatePeekState, 250);
        });
    })();
}


(function () {
    var DESKTOP_QUERY = '(min-width: 769px)';

    function isStackedContainer(sectionContainer) {
        var imagesEl = sectionContainer.querySelector('[data-product-images]');
        return !!imagesEl && imagesEl.dataset.galleryLayout === 'stacked';
    }

    function isDesktop() {
        return window.matchMedia(DESKTOP_QUERY).matches;
    }

    function syncStackedGallery() {
        if (!window.theme || !theme.sections || !theme.sections.instances) return;

        var desktop = isDesktop();

        theme.sections.instances.forEach(function (instance) {
            if (instance.type !== 'product') return;
            if (!isStackedContainer(instance.container)) return;

            var imagesEl = instance.container.querySelector('[data-product-images]');
            if (!imagesEl) return;

            if (desktop) {
                if (instance.flickity && instance.flickity.slideshow && typeof instance.flickity.slideshow.destroy === 'function') {
                    instance.flickity.slideshow.destroy();
                    instance.flickity = null;
                }
                imagesEl.dataset.hasSlideshow = 'false';
            } else {
                if (!instance.flickity && typeof instance.initProductSlider === 'function') {
                    instance.initProductSlider();
                }
                imagesEl.dataset.hasSlideshow = imagesEl.querySelectorAll('.product-main-slide').length > 1 ? 'true' : 'false';
            }

            imagesEl.classList.add('stacked-gallery--ready');
        });
    }

    document.addEventListener('DOMContentLoaded', syncStackedGallery);

    document.addEventListener('shopify:section:load', function () {
        setTimeout(syncStackedGallery, 0);
    });
    document.addEventListener('quickview:loaded', function () {
        setTimeout(syncStackedGallery, 0);
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(syncStackedGallery, 250);
    });
})();

document.addEventListener('ajaxProduct:error', function (evt) {
    var form = evt.target;
    var errorDiv = form && form.querySelector('.errors');
    if (!errorDiv) return;

    errorDiv.classList.add('errors--product-form');

    var addBtn = form.querySelector('[data-add-to-cart]');
    if (addBtn && addBtn.classList.contains('is-in-cart')) {
        errorDiv.textContent = theme.strings.maxQuantity;
    }
});
